import { render } from "./TabGroup.vue?vue&type=template&id=640a61aa&scoped=true"
import script from "./TabGroup.vue?vue&type=script&lang=js"
export * from "./TabGroup.vue?vue&type=script&lang=js"

import "./TabGroup.vue?vue&type=style&index=0&id=640a61aa&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640a61aa"]])

export default __exports__